/* eslint-disable no-undef */
import $ from "jquery";

const separatehousenumber = () => {
  const init = () => {
    changeBilling();
  };

  const changeBilling = () => {
    const el = {
      input: "#billing_house_number",
      address: "#billing_address_1",
      street: "#billing_streetname",
      additional: "#billing_additional",
      shippingAddress: "#shipping_address_1",
      shippingStreet: "#shipping_streetname",
      shippingInput: "#shipping_house_number",
      shippingAdditional: "#shipping_additional",
    };

    const handleInputBilling = () => {
      const val = `${$(el.street).val()}, ${$(el.input).val()} ${$(
        el.additional
      ).val()}`;
      $(el.address).val(val);
      $(el.shippingAddress).val(val);

      $(el.shippingStreet).val($(el.street).val());
      $(el.shippingInput).val($(el.input).val());
      $(el.shippingAdditional).val($(el.additional).val());
    };

    const handleChangeShipping = () => {
      const val = `${$(el.shippingStreet).val()}, ${$(
        el.shippingInput
      ).val()} ${$(el.shippingAdditional).val()}`;
      $(el.shippingAddress).val(val);
    };

    const trigredBlur = () => {
      // refresh myparcel option
      //   jQuery("body").trigger("country_to_state_changing");
      jQuery("body").trigger("update_order_review");
      jQuery("#billing_country, #shipping_country, .country_to_state").trigger(
        "change"
      );
    };

    $(document).on("blur", el.input, trigredBlur);
    $(document).on("blur", el.street, trigredBlur);
    $(document).on("blur", el.additional, trigredBlur);
    $(document).on("blur", el.shippingInput, trigredBlur);
    $(document).on("blur", el.shippingStreet, trigredBlur);
    $(document).on("blur", el.shippingAdditional, trigredBlur);

    $(document).on("input", el.input, handleInputBilling);
    $(document).on("input", el.street, handleInputBilling);
    $(document).on("input", el.additional, handleInputBilling);

    $(document).on("input", el.shippingInput, handleChangeShipping);
    $(document).on("input", el.shippingStreet, handleChangeShipping);
    $(document).on("input", el.shippingAdditional, handleChangeShipping);
  };

  init();
};

try {
  separatehousenumber();
} catch (error) {
  // eslint-disable-next-line no-console
  console.error(error);
}
